/**
 * ewc-cart — gaveta de carrinho independente de tema.
 *
 * Painel próprio, montado a partir do /cart.js. Não depende de seção do tema, de
 * re-render por "sections", nem da marcação da gaveta nativa (que fica escondida).
 * O único contato com o tema é o ADAPTADOR: o que abre a gaveta (link/ícone do
 * carrinho e formulário de compra) e onde fica o contador de itens. Tudo com
 * detecção automática e escape manual pela config.
 *
 * Falha aberto: qualquer erro deixa o tema funcionando como antes.
 */
(function () {
  'use strict';
  if (window.EwcCart) return;

  var PADRAO = {
    textos: {
      titulo: 'Your Cart', vazio: 'Your cart is empty', anuncio: '', recompensa_antes: 'Only {{restante}} away from a {{brinde}}',
      recompensa_depois: 'You got a {{brinde}}!', recompensa_final: '', economia: 'You Save', economia_linha: '(Save {{valor}})',
      subtotal: 'Subtotal', checkout: 'CHECKOUT →', remover: 'Remove', upsell_titulo: 'Add More & Save More', upsell_adicionar: 'Add',
      upsell_avaliacoes: '({{n}} reviews)', garantia: '', so_upsell: 'Add a product to check out', gratis: 'FREE'
    },
    cores: { destaque: '#111111', fundo: '#ffffff', texto: '#111111', recompensa: '#ecb4cc', trilho: '#e6e6e6', acento_fundo: '#f6f6f7', economia: '#05ac74', fechar_fundo: 'transparent' },
    largura: 440, raio: 10, timer_segundos: 0, mostrar_contagem: true,
    brinde: null, brindes: [], upsells: [], selos: [], selos_imagem: '', nota_item: null,
    modulos: { anuncio: true, recompensas: true, upsells: true, selos: true, gate_so_upsell: true, economia: true, subtotal: true, economia_linha: false, chips: true, rodape_vazio: true },
    adaptador: { gatilhos: '', contadores: '', gaveta_nativa: '', ignorar_formularios: '', abrir_ao_adicionar: true }
  };

  var SEL = {
    gatilhos: 'a[href$="/cart"],a[href*="/cart?"],a[href$="/cart/"],[data-cart-drawer-toggle],[data-cart-toggle],cart-drawer-toggle,' +
              '#cart-icon-bubble,.header__icon--cart,.cart-icon,.js-drawer-open-cart,[aria-controls="cart-drawer"],[aria-controls="CartDrawer"],[data-action="open-cart"]',
    contadores: '.cart-count-bubble span[aria-hidden],.cart-count-bubble span:not(.visually-hidden),[data-cart-count],.cart-count,.cart-item-count,' +
                '.header__cart-count,.cart-link__bubble-num,.site-header__cart-count span,[data-header-cart-count]',
    gaveta_nativa: 'cart-drawer,#CartDrawer,.cart-drawer,#cart-drawer,#shopify-section-cart-drawer,.drawer--cart,[data-cart-drawer],.mini-cart,#mini-cart,' +
                   '.cart-popup,cart-notification,#cart-notification,.cart-notification,.upcart-cart'
  };

  var cfg, raiz, refs = {}, carrinho = null, aberto = false, ocupado = false, relogio = null, cacheProduto = {}, produtoPronto = {};

  /* ------------------------------------------------------------ util */
  function juntar(base, extra) {
    var s = {};
    Object.keys(base).forEach(function (k) { s[k] = base[k]; });
    Object.keys(extra || {}).forEach(function (k) {
      if (extra[k] && typeof extra[k] === 'object' && !Array.isArray(extra[k]) && base[k] && typeof base[k] === 'object')
        s[k] = juntar(base[k], extra[k]);
      else if (extra[k] !== undefined && extra[k] !== null) s[k] = extra[k];
    });
    return s;
  }
  function lerConfig() {
    var no = document.querySelector('[data-ewc-cart-config]');
    var bruto = {};
    try { bruto = JSON.parse(no ? no.textContent : '{}'); } catch (e) { bruto = {}; }
    var c = juntar(PADRAO, bruto.config || {});
    c.moneyFormat = bruto.moneyFormat || '${{amount}}';
    c.rotas = bruto.rotas || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || c.rotas.raiz || '/';
    c.raiz = root.replace(/\/?$/, '/');
    return c;
  }
  function dinheiro(centavos) {
    var f = cfg.moneyFormat, v = (centavos / 100).toFixed(2), p = v.split('.');
    var inteiro = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/g, inteiro + '.' + p[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, inteiro)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.') + ',' + p[1])
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.'))
            .replace(/<[^>]*>/g, '');
  }
  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }
  function tpl(texto, vars) {
    return String(texto || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  /* os níveis de recompensa: `brindes[]` (novo) ou o `brinde` único (config antiga), do menor limiar ao maior */
  function niveis() {
    var lista = (cfg.brindes && cfg.brindes.length) ? cfg.brindes.slice() : (cfg.brinde && cfg.brinde.limiar ? [cfg.brinde] : []);
    return lista.filter(function (b) { return b && b.limiar; }).sort(function (a, b) { return a.limiar - b.limiar; });
  }
  function ehBrinde(item) {
    if (item.properties && item.properties._ewc_gift) return true;
    var vid = String(item.variant_id);
    return niveis().some(function (b) { return String(b.variante_id) === vid; }) || !!(cfg.brinde && vid === String(cfg.brinde.variante_id));
  }
  /* base das recompensas: tudo que não é brinde (o app da referência conta o total do carrinho) */
  function totalBase(c) { return c.items.filter(function (i) { return !ehBrinde(i); }).reduce(function (s, i) { return s + i.final_line_price; }, 0); }
  var ICONE_BRINDE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5h18v3H3zM4.5 12.5h15V20a1 1 0 01-1 1h-13a1 1 0 01-1-1zM12 9.5V21M12 9.5c-1.5-3.3-4.8-4.1-6-2.6s.3 3.4 6 2.6zm0 0c1.5-3.3 4.8-4.1 6-2.6s-.3 3.4-6 2.6z"/></svg>';
  var ICONE_LIXEIRA = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 4h11M6.3 4V2.7h3.4V4M3.9 4l.7 9.3c0 .6.5 1 1 1h4.8c.5 0 1-.4 1-1l.7-9.3M6.5 6.6v5.4M9.5 6.6v5.4"/></svg>';
  var ICONE_ETIQUETA = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M1.6 8.4V2.6a1 1 0 011-1h5.8a1 1 0 01.7.3l5.5 5.5a1 1 0 010 1.4l-5.7 5.7a1 1 0 01-1.4 0L1.9 9.1a1 1 0 01-.3-.7z"/><circle cx="5.1" cy="5.1" r="1" fill="currentColor" stroke="none"/></svg>';
  /* o título do desconto automático que o kit cria é "Etiqueta - Nome da barra — produto (id)";
     a etiqueta da linha mostra só o nome da barra, como o app da referência */
  function tituloDoDesconto(t) {
    var s = String(t || '').replace(/\s+—\s+.*$/, '');
    var m = /^(.*?)\s+-\s+(.+)$/.exec(s); return m ? m[2] : s;
  }
  function ehUpsell(item) { return !!(item.properties && (item.properties._ewc_upsell || item.properties.__upsell)); }
  function principais(c) { return c.items.filter(function (i) { return !ehBrinde(i) && !ehUpsell(i); }); }

  /* ------------------------------------------------------------ api */
  function pedir(rota, opts) {
    return fetch(cfg.raiz + rota, opts).then(function (r) {
      if (!r.ok) throw new Error(rota + ' ' + r.status);
      return r.json();
    });
  }
  var api = {
    carrinho: function () { return pedir('cart.js', { headers: { Accept: 'application/json' } }); },
    add: function (itens) {
      return pedir('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) });
    },
    change: function (chave, qtd) {
      return pedir('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: chave, quantity: qtd }) });
    },
    produto: function (handle) {
      if (cacheProduto[handle]) return cacheProduto[handle];
      cacheProduto[handle] = pedir('products/' + handle + '.js')
        .then(function (p) { if (p) produtoPronto[handle] = p; return p; })
        .catch(function () { delete cacheProduto[handle]; return null; });
      return cacheProduto[handle];
    }
  };

  /* ------------------------------------------------------------ montagem */
  function montar() {
    raiz.innerHTML = '';
    raiz.style.setProperty('--ewc-acento', cfg.cores.destaque);
    raiz.style.setProperty('--ewc-fundo', cfg.cores.fundo);
    raiz.style.setProperty('--ewc-texto', cfg.cores.texto);
    raiz.style.setProperty('--ewc-recompensa', cfg.cores.recompensa);
    raiz.style.setProperty('--ewc-largura', cfg.largura + 'px');
    raiz.style.setProperty('--ewc-raio', cfg.raio + 'px');
    if (cfg.fonte) raiz.style.setProperty('--ewc-fonte', cfg.fonte);
    raiz.style.setProperty('--ewc-trilho', cfg.cores.trilho); raiz.style.setProperty('--ewc-acento-fundo', cfg.cores.acento_fundo);
    raiz.style.setProperty('--ewc-economia', cfg.cores.economia); raiz.style.setProperty('--ewc-fechar-fundo', cfg.cores.fechar_fundo);
    if (cfg.adaptador && cfg.adaptador.css) { var extra = el('style'); extra.textContent = cfg.adaptador.css; raiz.appendChild(extra); }   // o que a config não cobre, por loja

    var fundo = el('div', 'ewc-cart__fundo'); fundo.addEventListener('click', fechar);
    var painel = el('aside', 'ewc-cart__painel'); painel.setAttribute('role', 'dialog'); painel.setAttribute('aria-modal', 'true');

    var topo = el('div', 'ewc-cart__topo');
    refs.titulo = el('h2', 'ewc-cart__titulo', cfg.textos.titulo);
    var fecharBtn = el('button', 'ewc-cart__fechar'); fecharBtn.type = 'button'; fecharBtn.setAttribute('aria-label', 'Close');
    fecharBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg>';
    fecharBtn.addEventListener('click', fechar);
    topo.appendChild(refs.titulo); topo.appendChild(fecharBtn);

    refs.anuncio = el('div', 'ewc-cart__anuncio'); refs.anuncio.hidden = true;
    refs.anuncioTexto = el('span', null, cfg.textos.anuncio); refs.timer = el('span', 'ewc-cart__timer');
    refs.anuncio.appendChild(refs.anuncioTexto); refs.anuncio.appendChild(refs.timer);

    refs.recompensas = el('div', 'ewc-cart__recompensas'); refs.recompensas.hidden = true;
    refs.recompensaMsg = el('div', 'ewc-cart__recompensas-msg');
    var trilhoCaixa = el('div', 'ewc-cart__trilho-caixa');
    var trilho = el('div', 'ewc-cart__trilho'); refs.preench = el('div', 'ewc-cart__preenchimento'); trilho.appendChild(refs.preench);
    trilhoCaixa.appendChild(trilho);
    refs.marcos = [];
    var lista = niveis(), nNiveis = lista.length;
    lista.forEach(function (b, i) {
      var marco = el('div', 'ewc-cart__marco');
      // medido no app da referência: os marcos dividem a barra em partes iguais, com o último
      // encostado na ponta (o círculo de 40 fica dentro do trilho)
      marco.style.left = (i === nNiveis - 1) ? 'calc(100% - 17.5px)' : 'calc(' + ((i + 1) / nNiveis * 100).toFixed(3) + '% + 10px)';
      var icone = el('div', 'ewc-cart__marco-icone'); icone.innerHTML = ICONE_BRINDE;
      marco.appendChild(icone); marco.appendChild(el('div', 'ewc-cart__marco-rotulo', b.rotulo || ''));
      trilhoCaixa.appendChild(marco);
      refs.marcos.push({ icone: icone, b: b });
    });
    refs.recompensas.appendChild(refs.recompensaMsg); refs.recompensas.appendChild(trilhoCaixa);

    refs.corpo = el('div', 'ewc-cart__corpo');
    refs.itens = el('div', 'ewc-cart__itens');
    refs.upsells = el('div', 'ewc-cart__upsells'); refs.upsells.hidden = true;
    refs.corpo.appendChild(refs.itens); refs.corpo.appendChild(refs.upsells);

    var rodape = el('div', 'ewc-cart__rodape'); refs.rodape = rodape;
    refs.economia = el('div', 'ewc-cart__economia'); refs.economia.hidden = true;
    refs.economia.appendChild(el('span', null, cfg.textos.economia)); refs.economiaValor = el('span'); refs.economia.appendChild(refs.economiaValor);
    refs.subtotalLinha = el('div', 'ewc-cart__subtotal'); refs.subtotalLinha.appendChild(el('span', null, cfg.textos.subtotal)); refs.subtotal = el('span'); refs.subtotalLinha.appendChild(refs.subtotal);
    refs.subtotalLinha.hidden = cfg.modulos.subtotal === false;
    refs.aviso = el('div', 'ewc-cart__aviso', cfg.textos.so_upsell); refs.aviso.hidden = true;
    refs.checkout = el('a', 'ewc-cart__checkout'); refs.checkout.innerHTML = tpl(cfg.textos.checkout, { total: '' }); refs.checkout.href = cfg.raiz + 'checkout';
    refs.checkout.addEventListener('click', function (ev) { if (refs.checkout.classList.contains('is-disabled')) ev.preventDefault(); });
    rodape.appendChild(refs.economia); rodape.appendChild(refs.subtotalLinha); rodape.appendChild(refs.aviso); rodape.appendChild(refs.checkout);
    if (cfg.textos.garantia) rodape.appendChild(el('p', 'ewc-cart__garantia', cfg.textos.garantia));
    if (cfg.selos_imagem) {
      // a referência mostra os meios de pagamento numa imagem só (selo de confiança), sob o botão
      var selosImg = el('div', 'ewc-cart__selos-imagem'); var im = el('img'); im.src = cfg.selos_imagem; im.alt = ''; im.loading = 'lazy';
      selosImg.appendChild(im); rodape.appendChild(selosImg);
    }
    if (cfg.modulos.selos && cfg.selos && cfg.selos.length) {
      var selos = el('div', 'ewc-cart__selos');
      cfg.selos.forEach(function (nome) {
        var svg = document.querySelector('template[data-ewc-selo="' + nome + '"]');
        if (svg) selos.appendChild(svg.content.cloneNode(true));
        else { var chip = el('span', 'ewc-cart__chip', String(nome).replace(/_/g, ' ').toUpperCase()); chip.style.background = '#eee'; chip.style.color = '#333'; selos.appendChild(chip); }
      });
      rodape.appendChild(selos);
    }

    painel.appendChild(topo); painel.appendChild(refs.anuncio); painel.appendChild(refs.recompensas);
    painel.appendChild(refs.corpo); painel.appendChild(rodape);
    raiz.appendChild(fundo); raiz.appendChild(painel);

    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-ewc-acao]');
      if (!b) return;
      var acao = b.getAttribute('data-ewc-acao'), chave = b.getAttribute('data-ewc-chave'), qtd = parseInt(b.getAttribute('data-ewc-qtd') || '0', 10);
      if (acao === 'mais') mudar(chave, qtd + 1);
      else if (acao === 'menos') mudar(chave, Math.max(0, qtd - 1));
      else if (acao === 'remover') mudar(chave, 0);
      else if (acao === 'upsell') adicionarUpsell(b);
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && aberto) fechar(); });
  }

  /* ------------------------------------------------------------ render */
  function render(c) {
    carrinho = c;
    var vazio = !c.items.length;
    refs.itens.innerHTML = '';
    if (vazio) refs.itens.appendChild(el('div', 'ewc-cart__vazio', cfg.textos.vazio));
    c.items.forEach(function (item) { refs.itens.appendChild(linha(item)); });

    refs.titulo.textContent = cfg.textos.titulo + (cfg.mostrar_contagem !== false && c.item_count ? ' • ' + c.item_count : '');
    refs.anuncio.hidden = !(cfg.modulos.anuncio && cfg.textos.anuncio && !vazio);
    if (!refs.anuncio.hidden) ligarTimer();

    var lista = niveis();
    if (cfg.modulos.recompensas && lista.length) {
      refs.recompensas.hidden = vazio;
      var total = totalBase(c), nNiveis = lista.length, k = -1, pct;
      for (var i = 0; i < nNiveis; i++) { if (total < Math.round(lista[i].limiar * 100)) { k = i; break; } }
      if (k < 0) pct = 100;
      else {
        // a barra anda por trechos iguais: dentro do trecho atual, a fração do que falta até o próximo nível
        var prev = k > 0 ? Math.round(lista[k - 1].limiar * 100) : 0, prevC = k > 0 ? k / nNiveis * 100 : 0;
        var alvo = Math.round(lista[k].limiar * 100), alvoC = (k + 1) / nNiveis * 100;
        pct = prevC + Math.max(0, total - prev) / (alvo - prev) * (alvoC - prevC);
      }
      refs.preench.style.width = Math.min(100, pct).toFixed(2) + '%';
      refs.marcos.forEach(function (m) { m.icone.classList.toggle('is-complete', total >= Math.round(m.b.limiar * 100)); });
      var msg;
      if (k < 0) msg = cfg.textos.recompensa_final || tpl(cfg.textos.recompensa_depois, { brinde: '<strong>' + (lista[nNiveis - 1].rotulo || '') + '</strong>' });
      else {
        var falta = dinheiro(Math.round(lista[k].limiar * 100) - total);
        msg = lista[k].texto_antes ? String(lista[k].texto_antes).replace(/\{AMOUNT\}|\{\{\s*restante\s*\}\}/g, falta)
          : tpl(cfg.textos.recompensa_antes, { restante: '<strong>' + falta + '</strong>', brinde: '<strong>' + (lista[k].rotulo || '') + '</strong>' });
      }
      refs.recompensaMsg.innerHTML = msg;
    } else refs.recompensas.hidden = true;

    // preço de tabela (compare-at) de cada linha vem do /products/x.js: quando chega, a linha é redesenhada
    c.items.forEach(function (i) { if (i.handle && !cacheProduto[i.handle]) api.produto(i.handle).then(function () { if (carrinho === c) render(c); }); });
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
    refs.subtotal.textContent = dinheiro(c.total_price);
    refs.checkout.innerHTML = tpl(cfg.textos.checkout, { total: dinheiro(c.total_price) });

    var soAcessorio = c.item_count > 0 && principais(c).length === 0 && cfg.modulos.gate_so_upsell;
    refs.checkout.classList.toggle('is-disabled', vazio || soAcessorio);
    refs.rodape.hidden = vazio && cfg.modulos.rodape_vazio === false;   // a referência mostra só a mensagem no carrinho vazio
    refs.aviso.hidden = !soAcessorio;

    renderUpsells(c);
    atualizarContadores(c.item_count);
    brindeAutomatico(c);
    document.dispatchEvent(new CustomEvent('ewc:cart:updated', { detail: { cart: c } }));
  }
  function atualizarEconomia(c) {
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
  }
  function compareAt(c) {
    // economia contra o preço de tabela, quando o produto tem compare-at (lido do /products/x.js já em cache)
    var soma = 0;
    c.items.forEach(function (i) {
      var p = produtoPronto[i.handle];
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.id === i.variant_id; })[0];
      if (v && v.compare_at_price > i.original_price) soma += (v.compare_at_price - i.original_price) * i.quantity;
    });
    return soma;
  }
  function precoCheioDaLinha(item) {
    // o preço de tabela da linha: o compare-at do produto (lido do /products/x.js) quando existe, senão o original
    var cheio = item.original_line_price, p = produtoPronto[item.handle];
    if (p) { var v = (p.variants || []).filter(function (x) { return x.id === item.variant_id; })[0]; if (v && v.compare_at_price > item.original_price) cheio = v.compare_at_price * item.quantity; }
    return cheio;
  }
  function linha(item) {
    var brinde = ehBrinde(item) || item.final_line_price === 0;
    var n = el('div', 'ewc-cart__item'); if (brinde) n.classList.add('ewc-cart__item--brinde');
    var img = el('img', 'ewc-cart__img'); if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
    var info = el('div', 'ewc-cart__info');
    var nome = el('h3', 'ewc-cart__nome'); var a = el('a', null, item.product_title); a.href = item.url; nome.appendChild(a);
    info.appendChild(nome);
    if (item.variant_title && item.variant_title !== 'Default Title') info.appendChild(el('p', 'ewc-cart__variante', item.variant_title));
    Object.keys(item.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && item.properties[k]) info.appendChild(el('p', 'ewc-cart__variante', k + ': ' + item.properties[k])); });
    var baixo = el('div', 'ewc-cart__linha-baixo');
    if (brinde) { if (cfg.textos.gratis) baixo.appendChild(el('span', 'ewc-cart__chip ewc-cart__chip--gratis', cfg.textos.gratis)); }
    else {
      var q = el('div', 'ewc-cart__qtd');
      var menos = el('button'); menos.type = 'button'; menos.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M2.5 6h7"/></svg>';
      menos.setAttribute('aria-label', 'Decrease quantity'); menos.setAttribute('data-ewc-acao', 'menos'); menos.setAttribute('data-ewc-chave', item.key); menos.setAttribute('data-ewc-qtd', item.quantity);
      var mais = el('button'); mais.type = 'button'; mais.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M2.5 6h7M6 2.5v7"/></svg>';
      mais.setAttribute('aria-label', 'Increase quantity'); mais.setAttribute('data-ewc-acao', 'mais'); mais.setAttribute('data-ewc-chave', item.key); mais.setAttribute('data-ewc-qtd', item.quantity);
      q.appendChild(menos); q.appendChild(el('span', null, String(item.quantity))); q.appendChild(mais); baixo.appendChild(q);
    }
    var precos = el('div', 'ewc-cart__precos');
    var linhaPreco = el('div', 'ewc-cart__preco');
    var cheio = precoCheioDaLinha(item);
    if (cheio > item.final_line_price) linhaPreco.appendChild(el('span', 'ewc-cart__riscado', dinheiro(cheio)));
    linhaPreco.appendChild(el('span', 'ewc-cart__preco-final', dinheiro(item.final_line_price)));
    precos.appendChild(linhaPreco);
    if (cfg.modulos.economia_linha && cheio > item.final_line_price) precos.appendChild(el('div', 'ewc-cart__economia-linha', tpl(cfg.textos.economia_linha, { valor: dinheiro(cheio - item.final_line_price) })));
    if (cfg.modulos.chips !== false) {
      var chips = el('div', 'ewc-cart__chips');
      (item.line_level_discount_allocations || []).forEach(function (al) {
        var t = al.discount_application && al.discount_application.title;
        if (!t) return;
        var chip = el('span', 'ewc-cart__chip'); chip.innerHTML = ICONE_ETIQUETA; chip.appendChild(document.createTextNode(tituloDoDesconto(t))); chips.appendChild(chip);
      });
      if (chips.childNodes.length) precos.appendChild(chips);
    }
    baixo.appendChild(precos); info.appendChild(baixo);
    var rem = el('button', 'ewc-cart__remover'); rem.type = 'button'; rem.innerHTML = ICONE_LIXEIRA; rem.setAttribute('aria-label', cfg.textos.remover);
    rem.setAttribute('data-ewc-acao', 'remover'); rem.setAttribute('data-ewc-chave', item.key);
    n.appendChild(img); n.appendChild(info); n.appendChild(rem);
    var nota = cfg.nota_item;
    if (nota && nota.texto && !brinde && (!nota.contem || String(item.product_title || '').toLowerCase().indexOf(String(nota.contem).toLowerCase()) >= 0)) n.appendChild(el('p', 'ewc-cart__nota', nota.texto));
    return n;
  }
  function renderUpsells(c) {
    if (!cfg.modulos.upsells || !cfg.upsells || !cfg.upsells.length || !c.items.length) { refs.upsells.hidden = true; return; }
    var noCarrinho = {}; c.items.forEach(function (i) { noCarrinho[i.handle] = true; });
    var candidatos = cfg.upsells.filter(function (u) {
      if (noCarrinho[u.handle]) return false;
      if (u.gatilho_handles && u.gatilho_handles.length) return u.gatilho_handles.some(function (h) { return noCarrinho[h]; });
      return true;
    });
    if (!candidatos.length) { refs.upsells.hidden = true; return; }
    refs.upsells.hidden = false; refs.upsells.innerHTML = '';
    refs.upsells.appendChild(el('p', 'ewc-cart__upsells-titulo', cfg.textos.upsell_titulo));
    candidatos.forEach(function (u) {
      var tile = el('div', 'ewc-cart__upsell'); tile.setAttribute('data-ewc-upsell', u.handle);
      refs.upsells.appendChild(tile);
      api.produto(u.handle).then(function (p) {
        if (!p) { tile.remove(); return; }
        var img = el('img', 'ewc-cart__upsell-img'); img.src = (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
        var info = el('div', 'ewc-cart__upsell-info');
        var tit = el('h3', 'ewc-cart__upsell-titulo'); var ta = el('a', null, u.titulo || p.title); ta.href = p.url || (cfg.raiz + 'products/' + p.handle); tit.appendChild(ta); info.appendChild(tit);
        var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var precoTxt = el('div', 'ewc-cart__upsell-preco');
        function pintarPreco(v) { precoTxt.innerHTML = (v.compare_at_price > v.price ? '<span class="ewc-cart__riscado">' + dinheiro(v.compare_at_price) + '</span>' : '') + '<span class="ewc-cart__preco-final">' + dinheiro(v.price) + '</span>'; }
        pintarPreco(v0); info.appendChild(precoTxt);
        if (u.nota) {
          // estrelas como o app da referência: cheias até a nota arredondada, vazias no resto, e a contagem ao lado
          var n = Math.max(0, Math.min(5, Number(u.nota))), cheias = Math.floor(n), fracao = Math.round((n - cheias) * 100), s = '';
          for (var i = 0; i < cheias; i++) s += '★';
          if (fracao > 0) s += '<span class="ewc-cart__estrela-parcial"><span class="ewc-cart__estrela-cheia" style="width:' + fracao + '%">★</span>☆</span>';
          for (var j = cheias + (fracao > 0 ? 1 : 0); j < 5; j++) s += '☆';
          var nota = el('div', 'ewc-cart__upsell-nota'); nota.innerHTML = '<span class="ewc-cart__estrelas">' + s + '</span>' + (u.avaliacoes ? '<span class="ewc-cart__upsell-avaliacoes">' + tpl(cfg.textos.upsell_avaliacoes, { n: u.avaliacoes }) + '</span>' : '');
          info.appendChild(nota);
        }
        var sel = null;
        if (p.variants.length > 1) {
          sel = el('select');
          p.variants.forEach(function (v) { var o = el('option', null, v.title); o.value = v.id; o.disabled = !v.available; sel.appendChild(o); });
          sel.value = String(v0.id);
          sel.addEventListener('change', function () { var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (v) pintarPreco(v); });
          info.appendChild(sel);
        }
        var btn = el('button', 'ewc-cart__upsell-add', u.botao || cfg.textos.upsell_adicionar); btn.type = 'button';
        btn.setAttribute('data-ewc-acao', 'upsell'); btn.setAttribute('data-ewc-variante', String(v0.id));
        if (sel) sel.addEventListener('change', function () { btn.setAttribute('data-ewc-variante', sel.value); });
        info.appendChild(btn);
        tile.appendChild(img); tile.appendChild(info);
      });
    });
  }

  /* ------------------------------------------------------------ ações */
  function atualizar() { return api.carrinho().then(render).catch(function () {}); }
  function mudar(chave, qtd) {
    if (ocupado) return; ocupado = true;
    api.change(chave, qtd).then(render).catch(function () {}).then(function () { ocupado = false; });
  }
  function adicionarUpsell(btn) {
    var vid = parseInt(btn.getAttribute('data-ewc-variante') || '0', 10); if (!vid || ocupado) return;
    ocupado = true; btn.disabled = true;
    api.add([{ id: vid, quantity: 1, properties: { _ewc_upsell: '1' } }]).then(atualizar).catch(function () {}).then(function () { ocupado = false; btn.disabled = false; });
  }
  var brindeOcupado = false;
  function brindeAutomatico(c) {
    var lista = niveis().filter(function (b) { return b.variante_id; }); if (!lista.length || brindeOcupado) return;
    var total = totalBase(c), temPrincipal = c.items.some(function (i) { return !ehBrinde(i) && !ehUpsell(i); });
    var ss = window.sessionStorage;
    function guardar(k, v) { try { v == null ? ss.removeItem(k) : ss.setItem(k, v); } catch (e) {} }
    function ler(k) { try { return ss.getItem(k); } catch (e) { return null; } }
    for (var i = 0; i < lista.length; i++) {
      var b = lista[i], vid = String(b.variante_id), limiar = Math.round(b.limiar * 100);
      var linhas = c.items.filter(function (it) { return String(it.variant_id) === vid; });
      var elegivel = total >= limiar && temPrincipal;
      var kAdd = 'ewcBrindeAdicionado:' + vid, kRem = 'ewcBrindeRemovido:' + vid;
      if (linhas.length && linhas[0].quantity > 1) {
        brindeOcupado = true;
        api.change(linhas[0].key, 1).then(function (nc) { brindeOcupado = false; render(nc); }).catch(function () { brindeOcupado = false; });
        return;
      }
      if (elegivel && !linhas.length) {
        if (ler(kAdd)) { guardar(kRem, '1'); guardar(kAdd, null); continue; }   // estava lá e sumiu: o cliente tirou de propósito, não volta nesta sessão
        if (ler(kRem)) continue;
        brindeOcupado = true;
        api.add([{ id: parseInt(vid, 10), quantity: 1, properties: { _ewc_gift: '1' } }])
          .then(function () { guardar(kAdd, '1'); brindeOcupado = false; return atualizar(); })   // o render seguinte cuida do próximo nível
          .catch(function () { brindeOcupado = false; });
        return;
      }
      if (!elegivel && linhas.length) {
        brindeOcupado = true;
        api.change(linhas[0].key, 0).then(function (nc) { guardar(kAdd, null); brindeOcupado = false; render(nc); }).catch(function () { brindeOcupado = false; });
        return;
      }
    }
  }
  function ligarTimer() {
    if (!cfg.timer_segundos) { refs.timer.textContent = ''; return; }
    var chave = 'ewcTimerInicio', inicio;
    try { inicio = parseInt(sessionStorage.getItem(chave) || '0', 10); } catch (e) { inicio = 0; }
    if (!inicio) { inicio = Date.now(); try { sessionStorage.setItem(chave, String(inicio)); } catch (e) {} }
    function tique() {
      var resta = Math.max(0, cfg.timer_segundos - Math.floor((Date.now() - inicio) / 1000));
      var m = Math.floor(resta / 60), s = resta % 60;
      refs.timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (resta === 0) { clearInterval(relogio); relogio = null; }
    }
    tique(); if (!relogio) relogio = setInterval(tique, 1000);
  }
  function atualizarContadores(n) {
    var sel = SEL.contadores + (cfg.adaptador.contadores ? ',' + cfg.adaptador.contadores : '');
    document.querySelectorAll(sel).forEach(function (e) {
      if (raiz.contains(e)) return;
      if (/^\s*\d*\s*$/.test(e.textContent)) e.textContent = String(n);
      else e.textContent = e.textContent.replace(/\d+/, String(n));
    });
  }

  /* ------------------------------------------------------------ abrir / fechar */
  function abrir() {
    if (aberto) return;
    aberto = true; raiz.hidden = false; raiz.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { raiz.classList.add('is-open'); });
    document.documentElement.classList.add('ewc-cart-aberto');
    atualizar();
    document.dispatchEvent(new CustomEvent('ewc:cart:open'));
  }
  function fechar() {
    if (!aberto) return;
    aberto = false; raiz.classList.remove('is-open'); document.documentElement.classList.remove('ewc-cart-aberto');
    setTimeout(function () { if (!aberto) { raiz.hidden = true; raiz.setAttribute('aria-hidden', 'true'); } }, 300);
  }

  /* ------------------------------------------------------------ adaptador */
  function esconderNativa() {
    var css = document.createElement('style');
    css.setAttribute('data-ewc-cart', 'esconde-nativa');
    var sel = SEL.gaveta_nativa + (cfg.adaptador.gaveta_nativa ? ',' + cfg.adaptador.gaveta_nativa : '');
    css.textContent = sel + '{display:none !important;visibility:hidden !important}';
    document.head.appendChild(css);
  }
  function instalarGatilhos() {
    var sel = SEL.gatilhos + (cfg.adaptador.gatilhos ? ',' + cfg.adaptador.gatilhos : '');
    document.addEventListener('click', function (ev) {
      var alvo = ev.target.closest && ev.target.closest(sel);
      if (!alvo || raiz.contains(alvo) || alvo.hasAttribute('data-ewc-skip')) return;
      var href = alvo.getAttribute('href') || '';
      if (href && !/\/cart(\/|\?|$)/.test(href)) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      abrir();
    }, true);
  }
  function itensDoFormulario(form) {
    var fd = new FormData(form), id = parseInt(fd.get('id') || '0', 10), qtd = parseInt(fd.get('quantity') || '1', 10) || 1, props = {};
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
    if (!id) return null;
    var item = { id: id, quantity: qtd }; if (Object.keys(props).length) item.properties = props;
    var plano = fd.get('selling_plan'); if (plano) item.selling_plan = plano;
    return [item];
  }
  function instalarFormularios() {
    var ignorar = cfg.adaptador.ignorar_formularios;
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (raiz.contains(form) || form.hasAttribute('data-ewc-skip') || form.hasAttribute('data-ewc-bundle-form')) return;
      if (ignorar && form.closest(ignorar)) return;
      var itens = itensDoFormulario(form); if (!itens) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"],button[name="add"]'); if (btn) btn.disabled = true;
      api.add(itens).then(function () { if (cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else atualizar(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);
  }
  function vigiarRede() {
    // o tema pode adicionar por JavaScript próprio (sem submit): ver a rede é o único gancho que vale em todo tema
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function' && !fetchOriginal._ewc) {
      var f = function (entrada, opts) {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        var p = fetchOriginal.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !(opts && opts.headers && opts.headers['X-Ewc'])) {
          p.then(function (r) {
            if (!r.ok) return;
            if (/\/cart\/add/.test(url) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar();
          }).catch(function () {});
        }
        return p;
      };
      f._ewc = true; window.fetch = f;
    }
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) { if (/\/cart\/add/.test(String(url)) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar(); }
        });
      }
      return abrirXhr.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ início */
  function iniciar() {
    raiz = document.getElementById('ewc-cart-root'); if (!raiz) return;
    cfg = lerConfig();
    montar(); esconderNativa(); instalarGatilhos(); instalarFormularios(); vigiarRede();
    document.addEventListener('ewc:cart:added', function () { abrir(); });
    document.addEventListener('cart:refresh', function () { if (aberto) atualizar(); });
    window.addEventListener('pageshow', function () { ocupado = false; brindeOcupado = false; if (aberto) atualizar(); else api.carrinho().then(function (c) { atualizarContadores(c.item_count); }).catch(function () {}); });
    api.carrinho().then(function (c) { carrinho = c; atualizarContadores(c.item_count); brindeAutomatico(c); }).catch(function () {});
    window.EwcCart = { abrir: abrir, fechar: fechar, atualizar: atualizar, carrinho: function () { return carrinho; }, config: function () { return cfg; } };
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  } catch (e) { /* falha aberto */ }
})();
